import React, { useContext } from "react";
import { AdviceGuidesContext } from "../../../features/risk/pages/advice-guides/context/advice-guides";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";

import { IncidentLogMain } from "../../../features/risk/pages/incident-log";
import {IncidentSelector} from "@/components/paginated-selector/incident-selector";

function IncidentLog() {

  return (
    <div className="flex h-full">
        <IncidentSelector/>
    </div>
  );
}

export default IncidentLog;
